import * as React from 'react';
import { CSP } from '../rql';
import CSPSquareCard from '../cms/components/csp_square_card';
import CSPWideCard from '../cms/components/csp_wide_card';
import { ConditionFilter } from '../cms/lib/metadata_helper';
import gql from 'graphql-tag';
import OverflowingRow from './overflowing_row';
import Tiles from './tiles';
import { isExperimentEnabled } from '../user_context_helpers';
import { experiments } from '../constants';

import { withUserContext, IUser, IUserContext } from './user_context_provider';

export interface IProps {
  title?: JSX.Element | React.ReactNode | string;
  subtitleHtml?: string;
  ledeHtml?: string;
  csps: CSP[];
  conditionFilter?: ConditionFilter;
  loading: boolean;
  action?: JSX.Element | React.ReactNode;
  expectedCount?: number;
  displayAsGrid?: boolean;
  hideMetadata?: boolean;
  id?: string;
  user?: IUser;
  shouldLinkToSellForm?: boolean;
}

export const CSPAdditionalTrackingFieldsFragment = gql`
  fragment CSPAdditionalTrackingFields on CSP {
    _id
    id
    slug
    brand {
      slug
    }
    categories {
      slug
      rootSlug
      parentCategories {
        slug
      }
    }
  }
`;

export const CSPCardFragment = gql`
  fragment CSPCard on CSP {
    _id
    id
    title
    slug
    webLink {
      path
      href
    }
    newListingsLink {
      path
    }
    usedListingsLink {
      path
    }
    image(input: {transform: "card_square"}) {
      source
    }
    brand {
      slug
    }
    categories {
      slug
      rootSlug
    }
    reviews {
      avgRating
      total
    }
    inventory {
      newLowPrice {
        display
        amount
        amountCents
        currency
      }
      usedLowPrice {
        display
        amount
        amountCents
        currency
      }
      usedTotal
      newTotal
    }
    ... CSPAdditionalTrackingFields
  }
  ${CSPAdditionalTrackingFieldsFragment}
  `;

export class CSPRow extends React.Component<IProps & IUserContext, null> {
  oneColumnCspActive() {
    return this.props.user?.experiments && isExperimentEnabled(this.props.user, experiments.ONE_COLUMN_CSP);
  }

  getCount() {
    if (this.props.loading) return this.props.expectedCount;

    return this.props.csps.length;
  }

  shouldBeOneWide() {
    return this.getCount() === 1;
  }

  shouldGrow() {
    if (!this.props.displayAsGrid) return true;
    if (this.props.displayAsGrid && this.getCount() <= 3) return true;
  }

  renderPlaceholder() {
    if (this.props.expectedCount === 1) {
      return <CSPWideCard />;
    }

    return <CSPSquareCard />;
  }

  renderCards() {
    const { conditionFilter, csps } = this.props;

    if (csps.length === 1) {
      return (
        <CSPWideCard
          conditionFilter={conditionFilter}
          csp={csps[0]}
          hideMetadata={this.props.hideMetadata}
          shouldLinkToSellForm={this.props.shouldLinkToSellForm}
        />
      );
    }

    return csps.map((page, idx) => (
      <CSPSquareCard
        conditionFilter={conditionFilter}
        csp={page}
        key={page.id}
        position={idx}
        hideMetadata={this.props.hideMetadata}
        renderAsHorizontal={csps.length < 4}
        shouldLinkToSellForm={this.props.shouldLinkToSellForm}
        singleCountNewListings={this.oneColumnCspActive()}
      />
    ));
  }

  render() {
    if (!this.props.loading && !this.props.csps.length) return null;

    return (
      <OverflowingRow
        title={this.props.title}
        subtitleHtml={this.props.subtitleHtml}
        ledeHtml={this.props.ledeHtml}
        action={this.props.action}
        collectionCount={this.getCount()}
        id={this.props.id}
      >
        <Tiles
          placeholder={this.renderPlaceholder()}
          loading={this.props.loading}
          expectedCount={this.props.expectedCount}
          singleRow={!this.props.displayAsGrid}
          oneWide={this.shouldBeOneWide()}
          largeTiles={!this.shouldBeOneWide()}
          grow={this.shouldGrow()}
        >
          {this.renderCards()}
        </Tiles>
      </OverflowingRow>
    );
  }
}

export default withUserContext(CSPRow);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/components/csp_row.tsx